<template>
  <div class="content">
    <div class="title-text">
      <p class="title">Artist Social Links</p>
      <p class="subtitle">
        Add your social media usernames here and have them show on your landing
        page.
      </p>
    </div>
    <div class="content-body">
      <div class="socials-card">
        <div class="card-content">
          <div class="social-input">
            <label for="instagram">Instagram</label>
            <div class="input-container">
              <InstagramIcon />
              <span class="social-prefix">{{
                socials["instagram"].prefix
              }}</span>
              <input
                v-model="socials['instagram'].username"
                type="text"
                id="instagram"
                placeholder=""
              />
            </div>
          </div>
          <div class="social-input">
            <label for="tiktok">TikTok</label>
            <div class="input-container">
              <TikTokIcon />
              <span class="social-prefix">{{ socials["tiktok"].prefix }}</span>
              <input
                v-model="socials['tiktok'].username"
                type="text"
                id="tiktok"
                placeholder=""
              />
            </div>
          </div>
          <div class="social-input">
            <label for="twitter">Twitter</label>
            <div class="input-container">
              <TwitterIcon />
              <span class="social-prefix">{{ socials["twitter"].prefix }}</span>
              <input
                v-model="socials['twitter'].username"
                type="text"
                id="twitter"
                placeholder=""
              />
            </div>
          </div>
          <div class="social-input">
            <label for="twitch">Twitch</label>
            <div class="input-container">
              <TwitchIcon />
              <span class="social-prefix">{{ socials["twitch"].prefix }}</span>
              <input
                v-model="socials['twitch'].username"
                type="text"
                id="twitch"
                placeholder=""
              />
            </div>
          </div>
          <div class="social-input">
            <label for="facebook">Facebook</label>
            <div class="input-container">
              <FacebookIcon />
              <span class="social-prefix">{{
                socials["facebook"].prefix
              }}</span>
              <input
                v-model="socials['facebook'].username"
                type="text"
                id="facebook"
                placeholder=""
              />
            </div>
          </div>
          <div class="social-input">
            <label for="website">Website</label>
            <div class="input-container">
              <WebsiteIcon />
              <input
                v-model="socials['website'].username"
                type="text"
                id="website"
                placeholder="https://www.example.com/"
              />
              <span v-if="!websiteValid" class="validation">
                Enter a website URL starting "http(s)://..."
              </span>
            </div>
          </div>
          <button
            @click="updateArtistSocials"
            :disabled="!websiteValid"
            class="button-default"
          >
            <span>Save</span>
          </button>
        </div>
      </div>
    </div>
    <SnackBar>
      <template v-slot:icon>
        <CopyIcon />
      </template>
    </SnackBar>
  </div>
</template>

<script>
import InstagramIcon from "../../../../public/img/icons/instagram.svg";
import TikTokIcon from "../../../../public/img/icons/tiktok.svg";
import TwitterIcon from "../../../../public/img/icons/twitter.svg";
import TwitchIcon from "../../../../public/img/icons/twitch.svg";
import FacebookIcon from "../../../../public/img/icons/facebook.svg";
import WebsiteIcon from "../../../../public/img/icons/website.svg";
import CopyIcon from "../../../../public/img/icons/copy.svg";
import {
  M_UPDATE_ARTIST_SOCIAL_BY_PK,
  M_UPDATE_ARTIST_SOCIALS,
  Q_ARTIST_SOCIALS
} from "@/graphql";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import "@/assets/scss/custom/vendors-extensions/_braintree.scss";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  name: "SocialProfiles",
  components: {
    InstagramIcon,
    TikTokIcon,
    TwitterIcon,
    TwitchIcon,
    FacebookIcon,
    WebsiteIcon,
    SnackBar,
    CopyIcon
  },
  data() {
    return {
      facebookToken: null,
      socials: {
        instagram: {
          name: "Instagram",
          type: "instagram",
          prefix: "https://www.instagram.com/",
          username: "",
          url: "",
          id: null
        },
        tiktok: {
          name: "TikTok",
          type: "tiktok",
          prefix: "https://www.tiktok.com/@",
          username: "",
          url: "",
          id: null
        },
        twitter: {
          name: "Twitter",
          type: "twitter",
          prefix: "https://www.twitter.com/",
          username: "",
          url: "",
          id: null
        },
        twitch: {
          name: "Twitch",
          type: "twitch",
          prefix: "https://www.twitch.tv/",
          username: "",
          url: "",
          id: null
        },
        facebook: {
          name: "Facebook",
          type: "facebook",
          prefix: "https://www.facebook.com/",
          username: "",
          url: "",
          id: null
        },
        website: {
          name: "Website",
          type: "website",
          prefix: "",
          username: "",
          url: "",
          id: null
        }
      }
    };
  },
  apollo: {
    artist_socials: {
      query: Q_ARTIST_SOCIALS,
      variables() {
        return {
          artist_id: this.artist.id
        };
      },
      result({ data }) {
        // reset socials
        for (let value of Object.values(this.socials)) {
          this.$set(value, "id", null);
          this.$set(value, "url", null);
          this.$set(value, "username", null);
        }
        if (data.artist_socials.length) {
          data.artist_socials.forEach(artist_social => {
            // this.socials[]
            this.$set(this.socials[artist_social.type], "id", artist_social.id);
            this.$set(
              this.socials[artist_social.type],
              "url",
              artist_social.url
            );
            this.$set(
              this.socials[artist_social.type],
              "username",
              artist_social.type === "website"
                ? artist_social.url
                : this.getUsername(artist_social.url)
            );
          });
        }
      }
    }
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    user() {
      return this.$store.getters.getUser;
    },
    snack() {
      return this.$store.getters.getSnack;
    },
    websiteValid() {
      const url = this.socials["website"].username;
      if (!url) return true;
      return !!url.match(
        /^(http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/
      );
    }
  },
  methods: {
    getUsername(url) {
      const splitBy = url.includes("@") ? "/@" : "/";
      const arr = url.split(splitBy);
      return arr[arr.length - 1] || arr[arr.length - 2];
    },
    getSocialUrl(social) {
      return social.prefix + social.username;
    },
    async updateArtistSocials() {
      const promises = [];
      const new_socials = [];
      const deleted_socials = [];
      const updated_socials = [];
      for (let [key, value] of Object.entries(this.socials)) {
        if (value.id && value.username) {
          // UPDATE - id & username exists
          updated_socials.push({
            id: value.id,
            url: this.getSocialUrl(value)
          });
        } else if (value.id && !value.username) {
          // DELETE - only id exists
          deleted_socials.push(value.id);
        } else if (!value.id && value.username) {
          // INSERT - only username exists
          new_socials.push({
            artist_id: this.artist.id,
            type: key,
            url: this.getSocialUrl(value)
          });
        }
      }
      try {
        await this.$apollo.mutate({
          mutation: M_UPDATE_ARTIST_SOCIALS,
          variables: {
            new_artist_socials: new_socials,
            deleted_artist_social_ids: deleted_socials
          }
        });
        updated_socials.forEach(social => {
          promises.push(
            this.$apollo.mutate({
              mutation: M_UPDATE_ARTIST_SOCIAL_BY_PK,
              variables: {
                id: social.id,
                url: social.url
              }
            })
          );
        });
        await Promise.all(promises);
        await this.$apollo.queries.artist_socials.refetch();
        await this.$store.dispatch("snack", {
          text: "Success! Artist social links have been updated!"
        });
        // });
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.socials-card {
  padding: 0 24px 24px;
  /* BG/type2 */
  background: $bg-type-2;
  /* Shadow */
  box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: white;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: $text-type-0;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
  }
  .card-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .social-input {
      width: 100%;
      margin-top: 24px;
      label {
        margin-left: 11px;
        /* 12/Bold */
        font-weight: bold;
        font-size: 12px;
        line-height: 15px;
        /* Text/type1 */
        color: #8786ab;
      }
      .input-container {
        margin-top: 6px;
        display: flex;
        align-items: center;
        padding: 11px 13px;
        /* Purple-dark */
        background: $purple-dark;
        /* Purple-stroke */
        border: 1px solid $purple-stroke;
        box-sizing: border-box;
        border-radius: 5px;
        svg {
          width: 24px;
          margin-right: 10px;
        }
        .social-prefix {
          /* 14/Regular */
          font-size: 14px;
          line-height: 17px;
          /* Text/type2 */
          color: $text-type-2;
        }
        input {
          //margin-top: 6px;
          //padding: 13px 11px;
          //width: 100%;
          flex: 1;
          /* Purple-dark */
          background: $purple-dark;
          /* Purple-stroke */
          //border: 1px solid #312F62;
          //box-sizing: border-box;
          //border-radius: 5px;
          outline: none;
          border: none;
          color: $text-type-0;
          /* 14/Regular */
          font-size: 14px;
          line-height: 17px;

          &:-webkit-autofill,
          &:-webkit-autofill:hover,
          &:-webkit-autofill:focus {
            border: none;
            -webkit-text-fill-color: $text-type-0;
            box-shadow: 0 0 0px 1000px $purple-dark inset;
            -webkit-box-shadow: 0 0 0px 1000px $purple-dark inset;
            box-shadow: 0 0 0px 1000px $purple-dark inset;
            transition: background-color 5000s ease-in-out 0s;
          }

          &:focus {
            outline: none;
            //border: 1px solid $purple;
          }
          &::placeholder {
            color: $text-type-2;
            /* 14/Regular */
            font-size: 14px;
            line-height: 17px;
          }
        }
        .validation {
          color: rgba(255, 0, 0, 0.651);
          font-size: 14px;
        }
      }
    }
    button {
      margin-top: 18px;
      padding: 9px 30px;
      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
}
@media (max-width: 600px) {
  .input-container {
    overflow: auto;
    svg {
      position: absolute;
    }
    .social-prefix,
    input#website {
      margin-left: 34px;
    }
  }
}
</style>
